import { forwardRef, ForwardedRef } from 'react';
import { Calendar, CalendarProps, CalendarSelectionMode, CalendarRef } from '../atoms';

export const ConfiguredCalendar = forwardRef(
  (props: CalendarProps<CalendarSelectionMode>, ref: ForwardedRef<CalendarRef>) => {
    const isRange = props.selectionMode === 'range';

    const defaultMask = isRange ? '99/99/9999 - 99/99/9999' : '99/99/9999';
    const defaultPlaceholder = isRange ? 'DD/MM/YYYY - DD/MM/YYYY' : 'DD/MM/YYYY';
    const defaultMaskSlotChar = isRange ? 'DD/MM/YYYY - DD/MM/YYYY' : 'DD/MM/YYYY';

    return (
      <Calendar
        ref={ref}
        {...props}
        dateFormat={props.dateFormat ?? 'dd/mm/yy'}
        mask={props.mask ?? defaultMask}
        placeholder={props.placeholder ?? defaultPlaceholder}
        maskSlotChar={props.maskSlotChar ?? defaultMaskSlotChar}
      />
    );
  }
);

ConfiguredCalendar.displayName = 'ConfiguredCalendar';

export type { CalendarProps, CalendarSelectionMode };
